export default "__VITE_ASSET__D49k1i2i__"